import { formatDate } from '@crehana/date';
export var humanizeISODate = function humanizeISODate(isoDate, languageCode) {
  return isoDate ? formatDate(isoDate, {
    outputFormat: 'DD MMM. YYYY',
    languageCode: languageCode
  }) : undefined;
};